import DragState from "../../services/drag/dragState";

export default {
  mounted: function () {
    this.wireUpItemDrag();
  },
  updated: function () {
    this.wireUpItemDrag();
  },
  beforeDestroy: function () {
    if (this.dragState) {
      this.dragState.stopDrag.bind(this);
    }
  },
  computed: {
    dragState: function (): DragState {
      return this.$store.state.interfaceStore.dragState;
    },
    $workArea: function (): JQuery {
      return $(this.$el);
    }
  },
  methods: {
    wireUpItemDrag() {
      this.$workArea.on('mousedown', this.draggableClasses.map(c => `.${c}`).join(', '), e => {
        // if ( $(e.target).is("input")){
        //   e.stopPropagation();
        //   return true
        // }
        if (e.which !== 1) {
          return false;
        }
        if ((<any>e).skipDrag || $(e.target).closest('.skip-drag').length > 0) {
          return true;
        }
        this.$store.commit('interfaceStore/startDrag', {
          event: e,
          draggableClasses: this.draggableClasses,
          droppableClasses: this.droppableClasses,
          isControlPanelElement: false,
          targetRoot: this.targetRoot,
          currentArea: this.dragArea,
        });
        return false;
      });

      this.$workArea.on('mousedown', '.propagate-drag', e => {
        if (e.which !== 1) {
          return false;
        }
        (<any>e).skipDrag = true;
        return true;
      });
    }
  },
  watch: {
    dragState: function (d: DragState) {
      const $document = $(document);

      if (d) {
        $document.on('mouseup.stopDrag', e => {
          this.$store.commit('interfaceStore/stopDrag');
        });
        this.$workArea.on('mousemove.stopDrag', '.grid-cell', function (event) {
          d.hoverOverGridCell($(this), event);
        });
        this.$workArea.on('mousemove.stopDrag', '.grid-element', function (event) {
          d.hoverOverGridElement($(this), event);
        });
        this.$workArea.on('mouseleave.stopDrag', '.matrix-grid', function (event) {
          d.leaveGrid($(this), event);
        });
        this.$workArea.on('mousemove.stopDrag', d.droppableSelector, function (event) {
          d.hoverOver($(this), event);
        });
        this.$workArea.on('mousemove.stopDrag', '.empty', function (event) {
          d.stopDragOnEmptyDropZone($(this), event);
        });
        $document.on('mousemove.stopDrag', e => {
          d.drag(e as any);
        });
      } else {
        $document.off('.stopDrag');
        this.$workArea.off('.stopDrag');
      }
    }
  },
};